module.exports = __webpack_public_path__ + "static/media/synopsis-correlations-and-automated-charting-02@2x.206d381a.png";